import AppLoading from "./AppLoading";

const reducer = {
  AppLoading
};

export default reducer;
